import tooltipImg from 'img/tooltip/setup-vigbo-gallery.png';
import React, { type FC, type RefObject } from 'react';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { type ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';

import styles from './SetupVigboGalleryTooltip.css';

interface Props {
    target: RefObject<HTMLElement> | Element | null;
    title: string;
    text: string;
    placement: ETooltipPlacement;
    usePortal?: boolean;
    onClose?: () => void;
    onShow?: () => void;
    closeOnContextMenu?: boolean;
}

export const SetupVigboGalleryTooltip: FC<Props> = ({ target, title, text, usePortal, placement, closeOnContextMenu, onClose, onShow }) => {
    return (
        <FloatingTooltip
            target={target}
            placement={placement}
            size={ETooltipSize.fit}
            closeOnContextMenu={closeOnContextMenu}
            onClose={onClose}
            onShow={onShow}
            usePortal={usePortal}
            qaId="setup-vigbo"
        >
            <div className={styles.root}>
                <div className={styles.textBlock}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.text}>{text}</div>
                </div>
                <img className={styles.image} src={tooltipImg} alt="Картинка в тултипе" />
            </div>
        </FloatingTooltip>
    );
};
